import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log';
import loadUserService from '../../services/load-user';
import { REQUEST_CURRENT_USER, setCurrentUser } from '../../state/actions/user';
import { getAtlassianAccountId } from '../../state/selectors/app';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const loadCurrentUserEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(REQUEST_CURRENT_USER)
		.map(() => getAtlassianAccountId(store.getState()))
		.filter((accountId) => accountId !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		.mergeMap((accountId) => loadUserService(store, accountId as string))
		.map((appData) => setCurrentUser(appData))
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.load-current-user.failure',
				'Failed to load current user data',
				error,
			);
			// no error flag, as this data is not critical for application
			return Observable.empty<never>();
		});
